export const ACTION_ORDER_ADD = 'ACTION_ORDER_ADD'
export const ACTION_ORDER_LIST = 'ACTION_ORDER_LIST'
export const ACTION_ORDER_LIST_FAIL = 'ACTION_ORDER_LIST_FAIL'
export const ACTION_ORDER_GET = 'ACTION_ORDER_GET'
export const ACTION_ORDER_GET_FAIL = 'ACTION_ORDER_GET_FAIL'
export const ACTION_USER_ORDER_GET = 'ACTION_USER_ORDER_GET'
export const ACTION_ORDER_WHITELIST = 'ACTION_ORDER_WHITELIST'
export const ACTION_ORDER_WHITELIST_FAIL = 'ACTION_ORDER_WHITELIST_FAIL'
export const ACTION_ORDER_OLD_OWNER = 'ACTION_ORDER_OLD_OWNER'
export const ACTION_ORDER_OLD_OWNER_FAIL = 'ACTION_ORDER_OLD_OWNER_FAIL'